// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"360":"4e9f37a3df9c484a","888":"f2fd0f1cf656e177"}[chunkId] + ".js";
};